import styled from 'styled-components';

export const Location = styled.div`
  font-size: 0;
  display: flex;
  align-items: center;
`;

export const LocationImg = styled.div`
  width: 16px;
  height: 20px;
  display: block;

  /* border: 1px solid #34f2c8; */
  /* vertical-align: middle; */

  position: relative;
  > .bg {
    position: absolute;
    top: -5px;
    bottom: -5px;
    left: -6px;
    right: -6px;

    background-image: url(${require('../img/location.png')});
    background-size: 100% 100%;
  }
`;

export const LocationText = styled.span`
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  text-shadow: 0px 1px 0px rgba(0, 0, 0, 0.44);

  margin-left: 7px;
  display: block;
`;
